module.exports = __webpack_public_path__ + "static/media/YonderMountainStringBandCabinFeverTour2010Handdrawn4colorscreenprint.f6b60ace.webp";